import React from "react";

const Loader = ({ className = "" }: { className?: string }) => {
    return (
        <div className={`flex items-center justify-center w-full h-full ${className}`}>
            <div className="relative w-12 h-12">
                {/* Premium SVG Gradient Spinner */}
                <svg
                    viewBox="0 0 50 50"
                    className="w-full h-full animate-spin"
                >
                    <defs>
                        <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#0077C8" />
                            <stop offset="100%" stopColor="#0077C8" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                    <circle
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        stroke="url(#spinner-gradient)"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeDasharray="90 150"
                    />
                </svg>

                {/* Inner brand-colored rotating ring */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <svg
                        viewBox="0 0 50 50"
                        className="w-6 h-6 animate-[spin_1.5s_linear_infinite_reverse]"
                    >
                        <circle
                            cx="25"
                            cy="25"
                            r="20"
                            fill="none"
                            stroke="#FCCC00"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="30 150"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default Loader;
